<div class="fc-app">
    <fc-header></fc-header>
    <div class="bg-container">
        <div class="container">
            <div class="enrollment-container">
                <div class="container-title">
                    <h1>Nonprofit - {{ title$ | async }} Enrollment</h1>
                </div>

                <main class="enrollment-form-tile">
                    <router-outlet></router-outlet>
                </main>
            </div>
        </div>
    </div>
    <fc-footer></fc-footer>
</div>
